import { Authenticator, useAuthenticator, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROOT_PATH } from '../common/constants';

type LocationProps = {
  state: {
    from: Location;
  };
};

const ALLOWED_IP = '125.206.245.152';

const Login = () => {
  const { route } = useAuthenticator((context) => [context.route]);
  const location = useLocation() as unknown as LocationProps;
  const navigate = useNavigate();
  const from = location.state?.from?.pathname || ROOT_PATH;
  const [isHidden, setIsHidden] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    let canProceed = true;
    fetch('https://geolocation-db.com/json/')
      .then((res) => res.json())
      .then((result) => {
        if (!canProceed) return;
        result.IPv4 === ALLOWED_IP ? setIsHidden(false) : setIsHidden(true);
      })
      .catch((err) => {
        console.log(err);
        setIsHidden(true);
      });

    return () => {
      canProceed = false;
    };
  }, []);

  useEffect(() => {
    if (route === 'authenticated') {
      navigate(from, { replace: true });
    }
  }, [route, navigate, from]);

  if (isHidden === undefined) return <div></div>;

  return (
    <View className="auth-wrapper">
      <Authenticator loginMechanisms={['email']} hideSignUp={isHidden} />
    </View>
  );
};

export default Login;
